.newOptionTextField {
    flex: 1;
    margin: 0px 10px 10px 0px;
}